var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.294 7.87128C25.2641 7.09285 25.2641 6.34436 25.2641 5.62581C25.2641 5.05696 24.815 4.60786 24.2461 4.60786C19.845 4.57792 16.4918 3.32046 13.7074 0.625896C13.3182 0.236681 12.6595 0.236681 12.2703 0.625896C9.48592 3.32046 6.13268 4.57792 1.7615 4.57792C1.19265 4.57792 0.743552 5.02702 0.743552 5.59587C0.743552 6.31442 0.743552 7.06291 0.713612 7.87128C0.563914 15.2664 0.354338 25.356 12.6595 29.6074C12.7793 29.6374 12.8691 29.6673 12.9889 29.6673C13.1086 29.6673 13.2284 29.6374 13.3182 29.6074C25.6234 25.356 25.4138 15.2664 25.294 7.87128Z",
    fill: "url(#paint0_linear_33958_12251)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33958_12251",
    x1: 6.99968,
    y1: 3.00065,
    x2: 26.333,
    y2: 28.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239683,
    stopColor: "#C8C8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#CBCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536558,
    stopColor: "#BCBBF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.46351ab639035146a611331a887f0737.svg";
export { ForwardRef as ReactComponent };